import { ReactNode } from 'react';

import { ClassicDomainContext } from '../hooks/useClassicDomain';

export function ClassicDomainProvider({
  children,
}: {
  children: ReactNode;
}): ReactNode {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const envClassicDomain = import.meta.env.VITE_FIM_CLASSIC_DOMAIN;
  const classicDomain = envClassicDomain ? String(envClassicDomain) : undefined;

  return (
    <ClassicDomainContext.Provider value={{ classicDomain }}>
      {children}
    </ClassicDomainContext.Provider>
  );
}
